import React from 'react';
import styled from 'styled-components';

import { Link } from 'components/core';
import { useDispensaryCategory } from 'src/hooks/use-dispensary-category';
import { useGetCustomCategoryLink } from 'src/dispensary/hooks/use-get-custom-category-link';

export function CategoryLink({ category, onSelect }) {
  const selectedCategory = useDispensaryCategory();
  const href = useGetCustomCategoryLink(category.customCategory, category.slug, category.key);
  const selected = category.key === selectedCategory?.key;

  return (
    <LinkContainer>
      {/* eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions */}
      <StyledLink href={href} selected={selected} onClick={onSelect} data-testid='menu-drawer-category-link'>
        {category.label}
      </StyledLink>
    </LinkContainer>
  );
}
const LinkContainer = styled.li`
  list-style: none;
`;

const StyledLink = styled(Link)`
  font-weight: bold;
  font-size: 22px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.grey[30]};
`;
